var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMushrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0057 16.002C13.3195 13.7395 15.2121 12 17.5 12C19.7879 12 21.6805 13.7395 21.9943 16.002C22.0449 16.3665 21.7497 16.6667 21.3915 16.6667H18.7972V17.4634C18.7972 18.2636 18.8741 19.0619 19.0267 19.8466L19.0641 20.0388C19.2616 21.0534 18.5066 22 17.5 22C16.4934 22 15.7384 21.0534 15.9359 20.0388L15.9733 19.8466C16.1259 19.0619 16.2028 18.2636 16.2028 17.4634V16.6667H13.6085C13.2503 16.6667 12.9551 16.3665 13.0057 16.002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C5.9327 4 2.56807 6.78318 2.01007 10.4032C1.92017 10.9864 2.44504 11.4667 3.08184 11.4667H7.69395V12.7414C7.69395 14.0218 7.55723 17.299 7.2858 18.5546L7.2193 18.8621C6.86835 20.4855 8.2105 22 10 22C11.7895 22 13.1316 20.4855 12.7807 18.8621L12.7142 18.5546C12.6758 18.3771 12.6402 18.1593 12.6072 17.9125C11.8923 17.5307 11.3874 16.7511 11.5199 15.7959C11.6345 14.9697 11.9109 14.1924 12.3167 13.501C12.3096 13.207 12.3061 12.9482 12.3061 12.7414V11.4667H14.2505C15.1847 10.8561 16.2976 10.5 17.5 10.5C17.6685 10.5 17.8352 10.507 17.9999 10.5207C17.9993 10.4821 17.9961 10.4429 17.9899 10.4032C17.4319 6.78318 14.0673 4 10 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMushrooms);
export default __webpack_public_path__ + "static/media/mushrooms.1a86b38d2b701d973769b8f5e3219452.svg";
export { ForwardRef as ReactComponent };